import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AdminMobileRoot } from './mobile/shell';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AdminMobileRoot>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AdminMobileRoot>
  </React.StrictMode>
);
